module.exports = __webpack_public_path__ + "static/img/c1.30d6b64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/c1.png
// module id = YdAZ
// module chunks = 0